import { brandPalette } from "@platform/ui";
import { useT } from "../i18n";

/**
 * Miniature of the auth-ui sign-in form in a brand color. Uses the same token derivation as the auth pages
 * (@platform/ui brandPalette), so the button text color shown here is the one visitors get.
 */
export function BrandPreviewCard({
  name,
  logoUrl,
  color,
}: {
  name: string;
  logoUrl?: string;
  color: string;
}) {
  const { t } = useT();
  const p = brandPalette(color);
  return (
    <div className="mx-auto w-full max-w-xs rounded-[var(--radius-card)] border border-line bg-paper p-6">
      <div className="mb-5 flex items-center gap-2">
        {logoUrl ? (
          <img src={logoUrl} alt="" className="h-8 max-w-[160px] object-contain" />
        ) : (
          <>
            <span
              aria-hidden
              className="inline-flex size-8 items-center justify-center rounded-lg"
              style={{ backgroundColor: p.primarySolid, color: p.primaryContrast }}
            >
              <svg viewBox="0 0 24 24" className="size-5" fill="none">
                <path d="M12 3l7 3v5c0 4.5-3 7.8-7 8.5-4-.7-7-4-7-8.5V6z" fill="currentColor" />
              </svg>
            </span>
            <span className="font-semibold">{name}</span>
          </>
        )}
      </div>
      <div className="mb-3 h-9 rounded-[var(--radius-control)] border border-line-strong" />
      <p className="mb-4 text-right text-xs font-medium" style={{ color: p.primaryDark }}>
        {t("branding.previewLink")}
      </p>
      <span
        className="block w-full rounded-[var(--radius-control)] py-2 text-center text-sm font-medium"
        style={{ backgroundColor: p.primarySolid, color: p.primaryContrast }}
      >
        {t("branding.previewButton")}
      </span>
    </div>
  );
}
